export default "__VITE_ASSET__oLdkVq7q__"